import { DefaultRow } from "@pdf/helpers/default-row/default-row";
import { jsPDF } from "jspdf";

export class FreeTextsRow extends DefaultRow {
  readonly number: string[];
  readonly displayName: string[];
  readonly content: string[];

  constructor(pdf: jsPDF, number: string[], displayName: string[], content: string[]) {
    super();
    this.number = number;
    this.displayName = displayName;
    this.content = content;

    this._textHeight = this.calculateRowTextHeight(pdf);
    this._rowHeight = this.calculateRowHeight(this.textHeight);
  }

  private calculateRowTextHeight(pdf: jsPDF) {
    return Math.max(
      ...[
        this.calculateCellTextHeight(pdf, this.number),
        this.calculateCellTextHeight(pdf, this.displayName),
        this.calculateCellTextHeight(pdf, this.content),
      ],
    );
  }
}
